import { render, staticRenderFns } from "./user-info-noc.vue?vue&type=template&id=3256de58&scoped=true&"
import script from "./user-info-noc.vue?vue&type=script&lang=js&"
export * from "./user-info-noc.vue?vue&type=script&lang=js&"
import style0 from "./user-info-noc.vue?vue&type=style&index=0&id=3256de58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3256de58",
  null
  
)

export default component.exports